export default __webpack_public_path__ + "static/first-09b8d7c1afc2ea5509e4383f7e0d40f0.jpg";